<template>
    <div v-if="attachList.length === 0">
        -
    </div>
    <div v-else>
        <div v-if='attachList.length === 1'>
            <p>
                <a class="attachName" v-if='attachList[0].preUrl' target='_blank'
                   :href='attachList[0].preUrl' :title="attachList[0].name">{{ attachList[0].name }}</a>
                <span class="attachName" v-else :title="attachList[0].name">{{ attachList[0].name }}</span>
                <a :href='attachList[0].downUrl' class='ml-10 mr-10'><i class='el-icon-my-daochu'></i></a>
            </p>
        </div>
        <div v-else>
            <el-popover
                    placement='top'
                    title='简历附件:'
                    width='200'
                    trigger='hover'>
                <el-button slot='reference' type="text" size="small"><span class="attachName">{{attachList[0].name}}</span><i class='el-icon-my-gengduobiaoqian'></i></el-button>
                <template v-show='attachList.length' >
                    <p style="margin: 10px 0;" v-for='(item, index) in attachList' :key="index">
                        <a v-if='item.preUrl' target='_blank'
                           :href='item.preUrl'>{{ item.name }}</a>
                        <span v-else>{{ item.name }}</span>
                        <a :href='item.downUrl' class='ml-10 mr-10'><i class='el-icon-my-daochu'></i></a>
                    </p>
                </template>
            </el-popover>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            attachList: {
                type: Array,
                default () {
                    return []
                }
            }
        }
    }
</script>

<style type="text/scss" scoped>
    .attachName{
        width: 70px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: bottom;
    }
</style>


// WEBPACK FOOTER //
// attachViewInList.vue?6d87bff5